import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Links.css';
import logo from '../../assets/logo.webp';
import backgroundImage from '../../assets/tresHam.webp';

const Links = () => {
  const navigate = useNavigate();

  const links = [
    {
      id: 'catalogo',
      title: 'NOSSO CATÁLOGO',
      url: '/#catalogo',
      isExternal: false,
      isHash: true
    },
    {
      id: 'whatsapp',
      title: 'FALE CONOSCO NO WHATSAPP',
      url: 'https://wa.me/5541998330446',
      isExternal: true
    },
    {
      id: 'instagram',
      title: 'SIGA-NOS NO INSTAGRAM',
      url: 'https://www.instagram.com/primeatsfoods/',
      isExternal: true
    },
    {
      id: 'site',
      title: 'NOSSO SITE INSTITUCIONAL',
      url: '/',
      isExternal: false
    },
    {
      id: 'trabalhe-conosco',
      title: 'TRABALHE CONOSCO',
      url: 'mailto:contato@primeats.com.br?subject=Trabalhe Conosco',
      isEmail: true
    }
  ];

  const handleLinkClick = (link) => {
    if (link.isHash) {
      // Se for hash, navega para home e depois faz scroll
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('catalogo');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else if (link.isEmail) {
      window.location.href = link.url;
    } else if (link.isExternal) {
      window.open(link.url, '_blank');
    } else {
      navigate(link.url);
    }
  };

  return (
    <div className="links-page" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="links-container">
        <div className="links-header">
          <div className="logo-wrapper">
            <div className="logo-glow"></div>
            <img src={logo} alt="Primeats Logo" className="links-logo" />
          </div>
          <p className="links-subtitle">Hambúrgueres premium e cortes frigoríficos para redes de fast food.</p>
        </div>

        <div className="links-list">
          {links.map((link) => (
            <button
              key={link.id}
              className="link-button"
              onClick={() => handleLinkClick(link)}
            >
              {link.title}
            </button>
          ))}
        </div>

        <div className="links-footer">
          <p>© 2025 Primeats. Todos os direitos reservados.</p>
        </div>
      </div>
    </div>
  );
};

export default Links;

